import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { CrossSiteRole, SiteRole } from "../roles";
export var ALL_SITE_ROLES = [].concat(_toConsumableArray(Object.values(SiteRole)), _toConsumableArray(Object.values(CrossSiteRole)));